import React from 'react';
import styled from 'styled-components';
import {Text} from '../../Widgets';
const config = require('../../data.json');

export default function Steps(props) {
  const {step, onClick} = props;

  return (
    <Wrapper>
      <TabBar>
        <TabItem isActived={step >= 0} onClick={() => onClick(0)}>
          <div className="point">
            <p>1</p>
          </div>
          <Text size="sm">購物車</Text>
        </TabItem>
        <TabItem isActived={step >= 1} onClick={() => onClick(1)}>
          <div className="line"></div>
          <div className="point">
            <p>2</p>
          </div>
          <Text size="sm">訂購資訊</Text>
        </TabItem>
        <TabItem isActived={step >= 2} onClick={() => onClick(2)}>
          <div className="line"></div>
          <div className="point">
            <p>3</p>
          </div>
          <Text size="sm">選擇付款方式</Text>
        </TabItem>
        <TabItem isActived={step >= 3} onClick={() => onClick(3)}>
          <div className="line"></div>
          <div className="point">
            <p>4</p>
          </div>
          <Text size="sm">訂單成立</Text>
        </TabItem>
        <TabItem isActived={step >= 4} onClick={() => onClick(4)}>
          <div className="line"></div>
          <div className="point">
            <p>5</p>
          </div>
          <Text size="sm">完成付款</Text>
        </TabItem>
      </TabBar>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 45px;
`;

const TabBar = styled.div`
  display: flex;
`;

const TabItem = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
  flex-direction: column;

  & > .line {
    position: absolute;
    width: calc(100% - 30px);
    height: 2px;
    top: 13px;
    left: calc(-1 * 50% + 15px);
    background-color: ${(props) =>
      props.isActived ? config.colors.main : '#cbcbcb'};
  }

  & > .point {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: ${(props) =>
      props.isActived ? config.colors.main : '#cbcbcb'};

    & > p {
      color: white;
      margin-bottom: 0px;
    }
  }
`;
